<template>
  <div class="mt-3">
    <div class="nk-ecwg7-ck">
      <canvas class="ecommerce-doughnut-s1" id="dogn"></canvas>
    </div>
    <ul class="nk-ecwg7-legends d-block">
      <li v-for="(label,index) in labels" :key="index" class="pb-0">
        <div class="title">
          <nk-dot size="lg" :color="colors[index]"></nk-dot>
          <span>{{ label }}</span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { watch, toRefs } from "vue";
import { NkDot } from "@core/components"
import { Chart, ArcElement, Tooltip, DoughnutController, Filler } from "chart.js"
Chart.register(DoughnutController, ArcElement, Tooltip, Filler);

export default {
  props: {
    labels: {
      required: true,
      type: Array
    },
    data: {
      required: true,
      type: Array,
    },
    colors: {
      required: true,
      type: Array
    },
    dataUnit: {
      type: String
    }
  },
  components: {
    NkDot
  },
  setup(props){
    const { data } = toRefs(props)
    watch(data, () => {
      let chartItem = document.getElementById('dogn').getContext('2d')
      new Chart(chartItem, {
        type: 'doughnut',
        data: {
          labels: props.labels,
          dataUnit: props.dataUnit,
          datasets: [
            {
              backgroundColor: props.colors,
              data: props.data
            }
          ]
        }
      })
    })
  },
  mounted() {
    this.$nextTick(()=>{

    })
  }
}
</script>

